import { axiosInstance } from "@/utilities";
import { API_BASE_URL } from "@/services/XCONS_ENV";
import type { ContactRoleRow } from "./people-filter.types";

/**
 * `GET /contacts?filter.role=…` (xcon-api!955). Con `storeCodes` acota a esos stores —los operadores
 * de sus sellers vinculados incluidos—; sin ellos, todo lo que el usuario puede ver. El `search`
 * matchea nombre, teléfono o email del lado del servidor.
 */
async function fetchRoleRows(
  role: "operator" | "customer",
  opts: {
    storeCodes?: string[];
    search?: string;
    signal?: AbortSignal;
    limit?: number;
  },
): Promise<ContactRoleRow[]> {
  const params = new URLSearchParams();
  params.set("filter.role", role);
  params.set("limit", String(opts.limit ?? 100));
  const stores = (opts.storeCodes ?? []).filter(Boolean);
  if (stores.length === 1) params.set("filter.storeCode", stores[0]);
  if (stores.length > 1)
    params.set("filter.storeCode", `$in:${stores.join(",")}`);
  if (opts.search?.trim()) params.set("search", opts.search.trim());

  const { data } = await axiosInstance.get(
    `${API_BASE_URL}/contacts?${params.toString()}`,
    {
      signal: opts.signal,
    },
  );
  return (data?.data ?? []) as ContactRoleRow[];
}

export const fetchOperatorRows = (opts: Parameters<typeof fetchRoleRows>[1]) =>
  fetchRoleRows("operator", opts);

export const fetchCustomerRows = (opts: Parameters<typeof fetchRoleRows>[1]) =>
  fetchRoleRows("customer", opts);
